import React from "react";

const Modal = ({ title, message, onYes, onCancel }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            {/* Modal Content */}
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 ml-0 md:ml-[300px]">
                {/* Title */}
                <h2 className="text-lg font-semibold text-gray-800 mb-4">{title}</h2>
                {/* Message */}
                <p className="text-gray-600 mb-6">{message}</p>

                {/* Buttons */}
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onYes}
                        className="px-4 py-2 text-white bg-custom-blue rounded hover:bg-blue-700"
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
